'use client';
// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ReactNode, useEffect, useState, useCallback } from 'react';

// svgs
import CloseIcon from '@/public/svg/close.svg';

// styles
import styles from './MyListQueryParamPopup.module.scss';

interface MyListQueryParamPopupProps {
  isOpen: boolean;
  text: ReactNode;
}

const MyListQueryParamPopup = (props: MyListQueryParamPopupProps) => {
  const { isOpen: isOpenProp, text: textProp } = props;
  const [isOpen, setIsOpen] = useState(isOpenProp);
  const [text, setText] = useState<ReactNode>(textProp);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    setIsOpen(isOpenProp);
    setText(textProp);
  }, [isOpenProp, textProp]);

  // this useEffect dismisses the popup when the escape key is pressed
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleClose]);

  return (
    <div className={styles.my_list_query_param_popup} hidden={!isOpen} role="status" data-sentry-component="MyListQueryParamPopup" data-sentry-source-file="MyListQueryParamPopup.tsx">
      {/* this span is needed to keep flexbox affecting the text as a whole, since there might be a link */}
      <span>
        {text}
      </span>
      <button
        className={styles.btn__close}
        onClick={handleClose}
        aria-label='Close'
      >
        <CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="MyListQueryParamPopup.tsx" />
      </button>
    </div>
  );
};

export default MyListQueryParamPopup;
